import { type ReactNode } from "react"
import { Header } from "~/components/reusable/Header"
import { FavoritePageButton } from "~/components/sidebar/FavoritePageButton"

type ModuleHeaderProps = {
  breadcrumb: ReactNode
  actions?: ReactNode
}

const ModuleHeader = ({ breadcrumb, actions }: ModuleHeaderProps) => {
  return (
    <Header>
      <div className="flex flex-row items-center gap-1">
        {breadcrumb}
        <FavoritePageButton />
      </div>
      <div className="flex flex-row items-center gap-2">{actions}</div>
    </Header>
  )
}

export default ModuleHeader
